import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Dynamically resolves the backend URL to match the hostname of the current window.
 * This ensures that if the frontend is loaded via localhost or a dynamic network IP (e.g., 10.58.24.13),
 * requests are correctly sent to the backend running on the same host (port 8000),
 * keeping the original .env configuration intact for external consumers.
 */
export function getBackendUrl() {
    const base = process.env.REACT_APP_BACKEND_URL || "https://api.sparkl.ac";
    return base;
    const currentHostname = window.location.hostname;
    if (!currentHostname) return base;

    try {
        const urlObj = new URL(base);
        // Replace backend hostname with current frontend hostname so local/network requests work seamlessly.
        urlObj.hostname = currentHostname;
        return urlObj.toString().replace(/\/$/, "");
    } catch {
        return `http://${currentHostname}`;
    }
}

/**
 * Dynamically resolves the WebSocket backend URL.
 */
export function getWsBackendUrl() {
    const base = getBackendUrl();
    return base.replace(/^https/, "wss");
}
